import React, { useEffect, useState } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";

const ReceiveIndent = () => {
  const [masters, setMasters] = useState([]);
  const [mastId, setMastId] = useState("");
  const [data, setData] = useState([]);
  useEffect(() => {
    loadMasters();
  }, []);
 const loadMasters = async () => {
  try {
    const res = await axios.post(
      `${REACT_APP_API_URL}api/receive-indent/master`,
      {
        action: "RI",
        hoId: 0,
        id: 0
      }
    );

    setMasters(res.data || []);
  } catch (err) {
    console.log(err);
  }
};
  useEffect(() => {
  if (mastId && /^\d+$/.test(mastId)) {
    loadData(mastId);
  } else {
    setData([]);
  }
}, [mastId]);
 const loadData = async (id) => {
  try {
    const res = await axios.post(
      `${REACT_APP_API_URL}api/receive-indent/list`,
      {
        action: "V",
        mastId: Number(id),
        hoId: 1,
        id: 1
      }
    );
    console.log("TABLE DATA:", res.data);
    setData(res.data || []);
  } catch (err) {
    console.log(err);
    setData([]);
  }
};
 const receive = async (row) => {
  if (!row || typeof row !== "object") {
    alert("Invalid row data");
    return;
  }
  if (!row.DispatchIndentId) {
    alert("Item not dispatched yet");
    return;
  }
  const reqQty = Number(row.ReqQty || 0);
  const dispatchQty = Number(row.NoOfItemsDisp || 0);
  const receivedQty = Number(row.NoOfItemRcv || 0);
  if (reqQty <= 0) {
    alert("Invalid requested quantity");
    return;
  }
  if (dispatchQty <= 0) {
    alert("Invalid dispatch quantity");
    return;
  }
  if (receivedQty > dispatchQty) {
    alert("Received quantity cannot exceed dispatch quantity");
    return;
  }
  const remainingQty = dispatchQty - receivedQty;
  if (remainingQty <= 0) {
    alert("Already fully received");
    return;
  }
  if (
    row.Status !== "Dispatched" &&
    row.Status !== "Partial"
  ) {
    alert("Invalid status for receiving");
    return;
  }
  try {
    const payload = {
      dispatchId: Number(row.DispatchIndentId),
      invoiceNo: `INV${Date.now()}`,
      receivedQty: remainingQty,
      damageQty: 0,
      remarks: "Received OK",
      userId: 1
    };
    if (!payload.dispatchId || payload.receivedQty <= 0) {
      alert("Invalid payload");
      return;
    }
    const res = await axios.post(
      `${REACT_APP_API_URL}api/receive-indent/receive`,
      payload
    );
    alert(res.data.message || "Received Successfully");
    loadData(mastId);
  } catch (err) {
    console.log(err);
    alert(
      err?.response?.data?.message ||
      "Receive failed"
    );
  }
};
  return (
    <div className="container-fluid p-4">
      <h4>Receive Indent</h4>
      <div className="row mb-3">
        <div className="col-md-4">
          <label>Select Request</label>
          <select
            className="form-control"
            value={mastId}
            onChange={(e) => {
            const value = e.target.value;
            if (/^\d*$/.test(value)) {
              setMastId(value);
            }
          }}
          >
          <option value="">-- Select Request --</option>
            {Array.isArray(masters) &&
              masters.map((m) => (
                <option
                  key={m.ReqIndentMastId}
                  value={m.ReqIndentMastId}
                >
                  {m.ReqIndentNo}
                </option>
              ))}
          </select>
        </div>
      </div>
      <table className="table table-bordered table-striped">
        <thead className="table-light">
          <tr>
            <th>#</th>
            <th>Item</th>
            <th>Requested Qty</th>
            <th>Dispatch Qty</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center">
                No Data Found
              </td>
            </tr>
          ) : (
            data.map((d, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>{d.ItemName || "--"}</td>
                <td>{Number(d.ReqQty || 0)}</td>
                <td>{Number(d.NoOfItemsDisp || 0)}</td>
                <td>
                  <span
                    className={`badge ${
                      d.Status === "Completed"
                        ? "bg-success"
                        : d.Status === "Dispatched"
                        ? "bg-warning text-dark"
                        : d.Status === "Partial"
                        ? "bg-info"
                        : "bg-secondary"
                    }`}
                  >
                    {d.Status || "Pending"}
                  </span>
                </td>
            <td>
              {(d.Status === "Dispatched" || d.Status === "Partial") ? (
                <button
                  className="btn btn-success btn-sm"
                  onClick={() => receive(d)}
                >
                  Receive
                </button>
              ) : (
                <span className="text-muted">--</span>
              )}
            </td>
          </tr>
        ))
      )}
    </tbody>
  </table>
  </div>
  );
};

export default ReceiveIndent;